/**
 * Canonical form of a dropdown option's label.
 *
 * A dropdown option's label is also its stored answer and the text a registrant
 * reads, so two labels a registrant cannot tell apart must not both exist. Two
 * kinds of invisible difference are normalized away here:
 *
 *   - surrounding whitespace — `Adray Arena␣␣` and `Adray Arena` are the same
 *     option, and only the trimmed length can overflow the 191-char column
 *   - repeated INNER whitespace — `Adray␣␣Arena` renders identically to
 *     `Adray␣Arena` in every browser, so shipping both shows a registrant the
 *     same choice twice
 *
 * Collapsing the label itself (rather than only the comparison key) is what
 * makes the survivor of a de-duplication read cleanly: keeping the first
 * occurrence verbatim would otherwise leave the double-spaced typo in place.
 *
 * `\s` covers non-breaking spaces and the other unicode blanks a spreadsheet
 * paste drags in, not just U+0020.
 *
 * Deliberately NOT case-folding: `Adray Arena` and `adray arena` are visibly
 * different, so they are kept and merely warned about.
 */
export const normalizeOptionLabel = (label: string): string =>
  label.trim().replace(/\s+/g, ' ')
